import { ApproachProfileItem as ApproachProfileItemInterface } from 'ff/debrief/models';

export class ApproachProfileItem {
    private data: ApproachProfileItemInterface;

    constructor(data: ApproachProfileItemInterface) {
        this.data = data;
    }

    getDistanceFromRunway(): number {
        return this.data.distance_nm;
    }

    getAltitude(): number {
        return this.data.altitude;
    }

    getFixName(): string {
        return this.data.fix_name;
    }

    getFixFunction(): string {
        return this.data.fix_function;
    }

    getLatitude(): number {
        return this.data.latitude;
    }

    getLongitude(): number {
        return this.data.longitude;
    }

    isFixFunction(type: string): boolean {
        return this.data.fix_function === type;
    }

    getRawData(): ApproachProfileItemInterface {
        return this.data;
    }
}
